import palette from '../theme/palette';

const variants = [
  {
    props: { color: 'internal' },
    style: {
      '& .MuiList-root': {
        border: `2px solid ${palette.internal.main}`,
        borderRadius: '8px',
      },
    },
  },
];

export default variants;
